import { IProductProps } from 'store/modules/product';
import { IProductSelosProps as IProductSelosPropsUtils } from 'utils/cards';

import CardsList from 'components/common/CardsList';

import * as S from './styles';

interface IProductSelosProps {
  product: IProductProps;
  productSelosPrimary: IProductSelosPropsUtils;
  setShowModalAboutFreeFreight(state: boolean): void;
}

export function ProductSelos({
  product,
  productSelosPrimary,
  setShowModalAboutFreeFreight,
}: IProductSelosProps) {
  return (
    <S.Container className="group-selos-tarja">
      {product.novidade && (
        <span className="tarjas novidade-tarja primary">Novidade</span>
      )}

      {/* {!!product.promocaoProgressiva &&
        product.promocaoProgressiva.id !== 38 && (
          <img
            src={product.promocaoProgressiva.imagemUrl}
            alt="Selo promoção"
            className="promotion-selo"
          />
        )} */}

      {product.possuiBrinde && (
        <div className="product-tarjas">
          {/* {product.freteGratis && (
            <img
              src="/images/card-icons/frete-gratis-tag.svg"
              alt="Frete Grátis"
              className="frete-gratis-tag"
              onClick={() => setShowModalAboutFreeFreight(true)}
            />
          )} */}
          {product.possuiBrinde && (
            <span className="tarjas ganhe-brinde-tarja">Ganhe brinde</span>
          )}
        </div>
      )}

      <CardsList
        hovered={true}
        productSelos={productSelosPrimary}
        animationSelo="only-expanded"
      />
    </S.Container>
  );
}
